/* thumbsup.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 14 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M0,14.4c0-1.9,0-3.8,0-5.7c0.7-0.1,1.2-0.3,1.5-1C2,6.9,2.6,6.1,3.3,5.4C4.5,4,5.6,2.5,6.1,0.6C6.3,0,6.7-0.2,7.3,0.2
                c0.6,0.4,0.9,1,0.8,1.7C8,2.5,7.7,3.1,7.5,3.7C7.4,4.2,7.1,4.7,7,5.2c-0.2,1,0.2,1.4,1.2,1.4c0.8-0.1,1.6-0.2,2.3-0.3
                c0.6-0.1,1.2-0.1,1.8-0.1c0.9,0.1,1.2,0.6,0.9,1.5c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.3,0,0.5,0.2,0.6c0.8,0.3,0.9,1.3,0.2,1.9
                c-0.4,0.4-0.4,0.4,0,0.7c0.6,0.5,0.6,1.2-0.1,1.7c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.3,0.3-0.2,0.6c0.4,0.7,0.3,1.1-0.4,1.5
                c-0.7,0.4-1.4,0.6-2.2,0.7c-0.5,0.1-1,0.1-1.6,0.2c-0.3,0-0.5,0-0.8,0c-0.4,0-0.9-0.1-1.3-0.1c-1.4-0.1-2.7-0.3-4-0.8
                c-0.6-0.2-1.2-0.4-1.8-0.6C0.7,14.4,0.3,14.4,0,14.4z"/>
        </svg>`
};
